import { render, staticRenderFns } from "./RegisterView.vue?vue&type=template&id=4cb78982"
import script from "./RegisterView.vue?vue&type=script&lang=js"
export * from "./RegisterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInputComponent: require('/home/node/app/components/ui/inputComponent.vue').default,UiIconsEyeClosed: require('/home/node/app/components/ui/icons/eyeClosed.vue').default,UiIconsEyeOpen: require('/home/node/app/components/ui/icons/eyeOpen.vue').default,UiButtonComponent: require('/home/node/app/components/ui/buttonComponent.vue').default,ControllerRegister: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/user/ControllerRegister.js').default})
